document.addEventListener('DOMContentLoaded', () => {
	// Restructure the Google translate widget so we can style it better
	let gtWidgetSelect = null

	let getGtWidgetSelect = setInterval(() => {
		gtWidgetSelect = document.querySelector('.goog-te-gadget > div')
		if (gtWidgetSelect) {
			clearInterval(getGtWidgetSelect)
			gtWidgetSelect.classList.add('gt-widget-select-wrapper')
			gtWidgetSelect.parentElement.parentElement.appendChild(gtWidgetSelect)
		}
	}, 100)

	// Google Translate iframe styling
	let translate_iframe = document.querySelector('.skiptranslate > iframe')
	let translate_dropdown_iframes = document.querySelectorAll(
		'iframe:not([src]).skiptranslate'
	)
	let int_handler = setInterval(() => {
		translate_iframe = document.querySelector('.skiptranslate > iframe')
		translate_dropdown_iframes = document.querySelectorAll(
			'iframe:not([src]).skiptranslate'
		)
		if (translate_iframe && translate_dropdown_iframes.length >= 2) {
			clearInterval(int_handler)
			const style_link = document.createElement('link')
			style_link.rel = 'stylesheet'
			style_link.href = '/assets/css/google-translate-bar.css'
			translate_iframe.contentWindow.document.head.appendChild(style_link)
			translate_dropdown_iframes.forEach(frame => {
				let style_link_copy = style_link.cloneNode()
				frame.contentWindow.document.head.appendChild(style_link_copy)
			})
		}
	}, 100)
})
